webpackJsonp([214462856607157],{

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(8);
	
	var _Layout = __webpack_require__(14);
	
	var _Misc = __webpack_require__(19);
	
	var _Footer = __webpack_require__(18);
	
	var _ribbonModule = __webpack_require__(36);
	
	var _ribbonModule2 = _interopRequireDefault(_ribbonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const imgStyle = css`
	//   border-radius: 5px;
	//   margin-bottom: 1.7rem;
	// `;
	
	/* eslint-disable */
	var linkStyles = /*#__PURE__*/(0, _reactEmotion.css)('box-shadow:none;');
	// import Img from 'gatsby-image';
	
	
	var InstitutionsIndex = function InstitutionsIndex(_ref) {
	  var data = _ref.data;
	  var institutions = data.allAirtableProfile.edges;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _ribbonModule2.default.cornerRibbon },
	      'Beta'
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        width: [1, 1, 720],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0]
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Institutions'
	      ),
	      _react2.default.createElement(
	        _Layout.Box,
	        null,
	        institutions.filter(function (post) {
	          return post.node.InstitutionName.length > 0;
	        }).map(function (_ref2) {
	          var post = _ref2.node;
	
	          return _react2.default.createElement(
	            _Layout.Box,
	            { key: post.id },
	            _react2.default.createElement(
	              _Misc.Link,
	              { to: post.URL_slug, className: linkStyles },
	              'Start date: ',
	              _react2.default.createElement(
	                _Misc.Timestamp,
	                null,
	                post.ProgramStartDate
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                post.InstitutionName
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Student Disciplines: ',
	                post.StudentDisciplines ? post.StudentDisciplines.map(function (d) {
	                  return d + ", ";
	                }) : " "
	              )
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer.Footer, null)
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = InstitutionsIndex;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-institutions-js-0eca9c28a95dd694ac34.js